import { render, staticRenderFns } from "./BlockBodyComponent.vue?vue&type=template&id=a299384c"
import script from "./BlockBodyComponent.vue?vue&type=script&lang=ts"
export * from "./BlockBodyComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports